import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants";
import { FeedInsertsListItemReorderBody } from "./feedInsertsReorder.types";

export const requestFeedInsertsReorder = async ({
  id,
  ...body
}: FeedInsertsListItemReorderBody): Promise<void> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesContent.FeedInserts,
      id,
      ApiRoutesContent.FeedInsertsReorder
    ),
    body
  );
};
